import $ from "jquery";
import axios from "axios";

const LIST_MORE_URL = '/rest/forum/topic/list'

export const forumTopicListShowMore = () => {
    $('.topic-list-footer__show-more').click(function () {
        event.stopPropagation();
        event.preventDefault();

        const categoryId = $(this).data('category-id');
        const defaultOffset = $(this).data('default-offset');
        const currentOffset = $(this).data('current-offset') !== undefined ?
            $(this).data('current-offset') :
            defaultOffset;

        axios.get(LIST_MORE_URL, {
            params: {
                categoryId: categoryId,
                offset: currentOffset,
            }
        })
            .then((response) => {
                $('.topic-list-container').append(response.data.data);

                const btn = $('.topic-list-footer__show-more');

                if (!response.data.isMore) {
                    btn.hide();

                    return;
                }

                btn.data('current-offset', currentOffset + defaultOffset);
            });

    });
};